import script from "./EntityCollectionsManager.vue?vue&type=script&setup=true&lang=js"
export * from "./EntityCollectionsManager.vue?vue&type=script&setup=true&lang=js"

import "./EntityCollectionsManager.vue?vue&type=style&index=0&id=04903a85&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-04903a85"]])

export default __exports__